module.exports = __webpack_public_path__ + "img/24.656c531a.jpg";